<template>
	<div class="config-list-container">
		<!-- 列表页 -->
		<template v-if="showFlag">
			<!-- 页面头部 -->
			<div class="page-header">
				<div class="header-content">
					<div class="header-icon">
						<svg class="icon" viewBox="0 0 24 24">
							<path d="M9,12A3,3 0 0,1 12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,2L14.39,5.42C15.92,7.31 17.68,8.83 19.61,10.12L12,4.04L4.39,10.12C6.32,8.83 8.08,7.31 9.61,5.42L12,2M20.97,11C21.43,11.64 21.76,12.37 21.95,13.15C22.06,13.5 22.13,13.86 22.16,14.22L19.61,10.12C20.09,10.36 20.54,10.66 20.97,11M3.03,11C3.46,10.66 3.91,10.36 4.39,10.12L1.84,14.22C1.87,13.86 1.94,13.5 2.05,13.15C2.24,12.37 2.57,11.64 3.03,11M12,18.73L19.61,24.85C17.68,23.56 15.92,22.04 14.39,20.15L12,23.57L9.61,20.15C8.08,22.04 6.32,23.56 4.39,24.85L12,18.73Z"/>
						</svg>
					</div>
					<div class="header-text">
						<h1 class="page-title">轮播图管理</h1>
						<p class="page-description">网站轮播图片的上传与配置管理</p>
					</div>
					<div class="header-actions">
						<el-button 
							type="primary" 
							icon="el-icon-plus" 
							@click="addCarouselHandler()" 
							class="add-carousel-btn"
						>
							新增轮播图
						</el-button>
					</div>
				</div>
			</div>

			<!-- 工具栏 - 批量操作 -->
			<div class="toolbar-section" v-show="dataListSelections.length > 0">
				<el-card class="toolbar-card" shadow="never">
					<div class="toolbar-content">
						<div class="selection-info">
							<i class="el-icon-info"></i>
							<span>已选择 <strong>{{ dataListSelections.length }}</strong> 项轮播图</span>
						</div>
						<div class="batch-actions">
							<el-button 
								v-if="isAuth('config','删除')"
								type="danger" 
								icon="el-icon-delete"
								@click="deleteHandler()"
								class="batch-delete-btn"
							>
								批量删除
							</el-button>
						</div>
					</div>
				</el-card>
			</div>

			<!-- 数据表格 -->
			<div class="table-section">
				<el-card class="table-card" shadow="never">
					<div class="table-header">
						<h2 class="table-title">轮播图列表</h2>
						<div class="table-actions">
							<el-button 
								icon="el-icon-refresh" 
								@click="getDataList()"
								:loading="dataListLoading"
								class="refresh-btn"
							>
								刷新
							</el-button>
						</div>
					</div>
					
					<el-table 
						class="data-table"
						:data="dataList"
						v-loading="dataListLoading"
						@selection-change="selectionChangeHandler"
						empty-text="暂无轮播图配置"
						element-loading-text="加载中..."
						element-loading-spinner="el-icon-loading"
					>
						<el-table-column 
							type="selection" 
							width="55" 
							align="center"
						></el-table-column>
						
						<el-table-column 
							label="序号" 
							type="index" 
							width="70" 
							align="center"
							:index="getTableIndex"
						></el-table-column>
						
						<el-table-column 
							prop="name"
							label="轮播图名称"
							min-width="300"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="config-name">
									<div class="config-icon">
										<svg viewBox="0 0 24 24">
											<path d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.22,15.05 2.27,14.78 2.46,14.63L4.57,12.97C4.53,12.65 4.5,12.33 4.5,12C4.5,11.67 4.53,11.34 4.57,11.03L2.46,9.37C2.27,9.22 2.22,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11.03C19.47,11.34 19.5,11.67 19.5,12C19.5,12.33 19.47,12.65 19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z"/>
										</svg>
									</div>
									<div class="config-info">
										<div class="config-title">{{ scope.row.name }}</div>
										<div class="config-description">{{ getConfigDescription(scope.row.name) }}</div>
									</div>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="轮播图" 
							width="280" 
							align="center"
						>
							<template slot-scope="scope">
								<div class="config-value">
									<div class="value-image" v-if="scope.row.value">
										<img 
											v-if="scope.row.value.substring(0,4)=='http'" 
											:src="scope.row.value.split(',')[0]" 
											class="config-img"
											@error="handleImageError"
											@load="handleImageLoad"
										>
										<img 
											v-else 
											:src="$base.url+scope.row.value.split(',')[0]" 
											class="config-img"
											@error="handleImageError"
											@load="handleImageLoad"
										>
										<div class="image-overlay">
											<i class="el-icon-zoom-in" @click="previewImage(scope.row.value)"></i>
										</div>
									</div>
									<div class="no-value" v-else>
										<i class="el-icon-picture-outline"></i>
										<span>未配置</span>
									</div>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="操作" 
							width="240" 
							align="center"
							fixed="right"
						>
							<template slot-scope="scope">
								<div class="action-buttons">
									<el-button 
										v-if="isAuth('config','查看')" 
										type="info" 
										size="mini" 
										icon="el-icon-view"
										@click="addOrUpdateHandler(scope.row.id, 'info')"
										class="action-btn view-btn"
									>
										详情
									</el-button>
									<el-button 
										v-if="isAuth('config','修改')" 
										type="primary" 
										size="mini" 
										icon="el-icon-edit"
										@click="addOrUpdateHandler(scope.row.id)"
										class="action-btn edit-btn"
									>
										编辑
									</el-button>
									<el-button 
										v-if="isAuth('config','删除')" 
										type="danger" 
										size="mini" 
										icon="el-icon-delete"
										@click="deleteHandler(scope.row.id)"
										class="action-btn delete-btn"
									>
										删除
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</div>

			<!-- 分页 -->
			<div class="pagination-section">
				<el-pagination
					@size-change="sizeChangeHandle"
					@current-change="currentChangeHandle"
					:current-page="pageIndex"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalPage"
					class="data-pagination"
				></el-pagination>
			</div>
		</template>
		
		<!-- 添加/修改页面 -->
		<add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>

		<!-- 图片预览对话框 -->
		<el-dialog
			:visible.sync="previewVisible"
			title="图片预览"
			width="60%"
			class="preview-dialog"
		>
			<div class="image-preview-container">
				<img :src="previewImageUrl" class="preview-image" />
			</div>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'
import AddOrUpdate from "./add-or-update";
export default {
  data() {
    return {
      searchForm: {
        key: ""
      },
      form:{},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      sfshVisiable: false,
      shForm: {},
      chartVisiable: false,
      chartVisiable1: false,
      chartVisiable2: false,
      chartVisiable3: false,
      chartVisiable4: false,
      chartVisiable5: false,
      addOrUpdateFlag:false,
      layouts: ["total","prev","pager","next","sizes","jumper"],
      previewVisible: false,
      previewImageUrl: '',

    };
  },
  created() {
    this.init();
    this.getDataList();
    this.contentStyleChange()
  },
  mounted() {
  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
    }
  },
  components: {
    AddOrUpdate,
  },
  methods: {

    contentStyleChange() {
      this.contentPageStyleChange()
    },
    // 分页
    contentPageStyleChange(){
      let arr = []

      // if(this.contents.pageTotal) arr.push('total')
      // if(this.contents.pageSizes) arr.push('sizes')
      // if(this.contents.pagePrevNext){
      //   arr.push('prev')
      //   if(this.contents.pagePager) arr.push('pager')
      //   arr.push('next')
      // }
      // if(this.contents.pageJumper) arr.push('jumper')
      // this.layouts = arr.join()
      // this.contents.pageEachNum = 10
    },








    init () {
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'id',
        order: 'desc',
      }
      // 移除name限制，显示所有配置项（包括轮播图）
      // params['name'] = '%picture%'
      this.$http({
        url: "config/page",
        method: "get",
        params: params
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.totalPage = data.data.total;
          console.log('Config数据:', this.dataList);
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id,type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      if(type!='info'){
        type = 'else';
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type);
      });
    },
    // 新增轮播图
    addCarouselHandler() {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(null, 'carousel');
      });
    },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 删除
    deleteHandler(id) {
      var ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => {
            return Number(item.id);
          });
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "config/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },

    // 获取配置项描述
    getConfigDescription(name) {
      switch (name) {
        case 'logo':
          return '网站Logo图片';
        case 'banner':
          return '首页Banner图片';
        case 'footerLogo':
          return '底部Logo图片';
        case 'aboutUsImage':
          return '关于我们页面图片';
        case 'contactUsImage':
          return '联系我们页面图片';
        case 'newsImage':
          return '新闻页面图片';
        case 'productImage':
          return '产品页面图片';
        case 'serviceImage':
          return '服务页面图片';
        case 'partnerImage':
          return '合作伙伴页面图片';
        case 'galleryImage':
          return '画廊页面图片';
        case 'blogImage':
          return '博客页面图片';
        case 'faqImage':
          return '常见问题页面图片';
        case 'privacyPolicyImage':
          return '隐私政策页面图片';
        case 'termsOfServiceImage':
          return '服务条款页面图片';
        case 'cookiePolicyImage':
          return 'Cookie政策页面图片';
        case 'copyrightImage':
          return '版权页面图片';
        case 'disclaimerImage':
          return '免责声明页面图片';
        case 'contactUsImage':
          return '联系我们页面图片';
        default:
          return '未配置';
      }
    },

    // 预览图片
    previewImage(value) {
      if (value) {
        const imagePath = value.split(',')[0];
        // 判断是否是完整的HTTP URL
        if (imagePath.substring(0, 4) === 'http') {
          this.previewImageUrl = imagePath;
        } else {
          this.previewImageUrl = this.$base.url + imagePath;
        }
        this.previewVisible = true;
      }
    },

    // 处理图片加载失败
    handleImageError(event) {
      console.log('图片加载失败:', event.target.src);
      event.target.style.display = 'none';
      // 可以设置默认图片，但先隐藏看看是否是路径问题
      // event.target.src = this.$base.url + 'static/images/default.png';
    },

    // 处理图片加载成功
    handleImageLoad(event) {
      console.log('图片加载成功:', event.target.src);
    },

    // 获取表格序号
    getTableIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    }

  }

};
</script>
<style lang="scss" scoped>
.config-list-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-icon {
			width: 56px;
			height: 56px;
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);

			.icon {
				width: 24px;
				height: 24px;
				fill: white;
			}
		}

		.header-text {
			flex: 1;
			margin-left: 16px;

			.page-title {
				font-size: 24px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 4px 0;
			}

			.page-description {
				color: #64748b;
				font-size: 14px;
				margin: 0;
			}
		}

		.header-actions {
			margin-left: 24px;

			.add-carousel-btn {
				padding: 12px 24px;
				font-size: 14px;
				font-weight: 600;
				color: white;
				background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
				border: none;
				border-radius: 8px;
				box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
				transition: all 0.3s ease;
				position: relative;
				overflow: hidden;

				&::before {
					content: '';
					position: absolute;
					top: 0;
					left: -100%;
					width: 100%;
					height: 100%;
					background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
					transition: left 0.5s;
					}

				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
					
					&::before {
						left: 100%;
					}
				}

				&:active {
					transform: translateY(-1px);
				}

				i {
					margin-right: 6px;
					font-size: 16px;
				}
			}
		}
	}
}

// 工具栏
.toolbar-section {
	margin-bottom: 24px;

	.toolbar-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 0;
		}
	}

	.toolbar-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 24px;
		border-bottom: 1px solid #f1f5f9;

		.selection-info {
			display: flex;
			align-items: center;
			color: #4b5563;
			font-size: 14px;

			i {
				margin-right: 8px;
				font-size: 18px;
				color: #6b7280;
			}
		}

		.batch-actions {
			display: flex;
			gap: 12px;
			align-items: center;

			.batch-delete-btn {
				background: #ef4444;
				border-color: #ef4444;
				color: white;
				font-size: 13px;
				padding: 8px 16px;

				&:hover:not(:disabled) {
					background: #dc2626;
					border-color: #dc2626;
				}

				&:disabled {
					background: #f3f4f6;
					border-color: #d1d5db;
					color: #9ca3af;
				}
			}
		}
	}
}

// 表格区域
.table-section {
	margin-bottom: 24px;

	.table-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 0;
		}
	}

	.table-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 24px;
		border-bottom: 1px solid #f1f5f9;

		.table-title {
			font-size: 18px;
			font-weight: 600;
			color: #1e293b;
			margin: 0;
		}

		.table-actions {
			display: flex;
			gap: 12px;
			align-items: center;

			.refresh-btn {
				padding: 8px 16px;
				font-size: 13px;
				border-color: #d1d5db;
				color: #6b7280;

				&:hover {
					border-color: #9ca3af;
					color: #374151;
				}
			}
		}
	}

	.data-table {
		:deep(.el-table__header) {
			th {
				background: #f8fafc;
				color: #374151;
				font-weight: 600;
				border-bottom: 1px solid #e5e7eb;
				padding: 16px 0;

				.cell {
					padding: 0 16px;
				}
			}
		}

		:deep(.el-table__body) {
			tr {
				&:hover {
					background: #f8fafc;
				}

				td {
					border-bottom: 1px solid #f1f5f9;
					padding: 16px 0;

					.cell {
						padding: 0 16px;
					}
				}
			}
		}

		// 轮播图名称
		.config-name {
			display: flex;
			align-items: center;
			gap: 12px;

			.config-icon {
				width: 32px;
				height: 32px;
				background: #f3f4f6;
				border-radius: 6px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;

				svg {
					width: 16px;
					height: 16px;
					fill: #6b7280;
				}
			}

			.config-info {
				.config-title {
					font-size: 14px;
					font-weight: 600;
					color: #1e293b;
					margin-bottom: 2px;
				}

				.config-description {
					font-size: 12px;
					color: #6b7280;
				}
			}
		}

		// 轮播图
		.config-value {
			.value-image {
				position: relative;
				display: inline-block;

				.config-img {
					width: 120px;
					height: 80px;
					object-fit: cover;
					border-radius: 6px;
					border: 1px solid #e5e7eb;
				}

				&:hover .image-overlay {
					opacity: 1;
				}

				.image-overlay {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background: rgba(0, 0, 0, 0.5);
					border-radius: 6px;
					display: flex;
					align-items: center;
					justify-content: center;
					opacity: 0;
					transition: opacity 0.2s ease;
					cursor: pointer;

					i {
						color: white;
						font-size: 20px;
					}

					&:hover {
						opacity: 1;
					}
				}
			}

			.no-value {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				color: #9ca3af;
				font-size: 12px;
				padding: 20px;

				i {
					font-size: 32px;
					margin-bottom: 8px;
				}
			}
		}

		// 操作按钮
		.action-buttons {
			display: flex;
			gap: 10px;
			justify-content: center;
			flex-wrap: wrap;

			.action-btn {
				padding: 8px 14px;
				font-size: 12px;
				border-radius: 4px;
				min-width: 60px;
				white-space: nowrap;

				&.view-btn {
					background: #6b7280;
					border-color: #6b7280;
					color: white;

					&:hover {
						background: #4b5563;
						border-color: #4b5563;
					}
				}

				&.edit-btn {
					background: #6b7280;
					border-color: #6b7280;

					&:hover {
						background: #374151;
						border-color: #374151;
					}
				}

				&.delete-btn {
					background: #ef4444;
					border-color: #ef4444;
					color: white;

					&:hover {
						background: #dc2626;
						border-color: #dc2626;
					}
				}
			}
		}
	}
}

// 分页区域
.pagination-section {
	display: flex;
	justify-content: center;

	.data-pagination {
		background: white;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
}

// 图片预览对话框
.preview-dialog {
	:deep(.el-dialog) {
		border-radius: 8px;
	}

	:deep(.el-dialog__header) {
		background: #f8fafc;
		border-bottom: 1px solid #e5e7eb;
		padding: 16px 24px;

		.el-dialog__title {
			font-weight: 600;
			color: #1e293b;
		}
	}

	:deep(.el-dialog__body) {
		padding: 24px;
	}

	.image-preview-container {
		text-align: center;

		.preview-image {
			max-width: 100%;
			max-height: 500px;
			border-radius: 8px;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		}
	}
}

// 响应式设计
@media (max-width: 1200px) {
	.config-list-container {
		padding: 20px;
	}

	.page-header {
		.header-content {
			padding: 20px;
		}
	}

	.toolbar-section {
		.toolbar-card {
			padding: 16px;
		}
	}

	.table-section {
		overflow-x: auto;

		.data-table {
			min-width: 900px;

			.config-value {
				.value-image {
					.config-img {
						width: 60px;
						height: 60px;
					}
				}
			}

			.action-buttons {
				flex-direction: column;
				gap: 4px;

				.action-btn {
					width: 100%;
					max-width: 60px;
					padding: 4px 8px;
					font-size: 11px;
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.config-list-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;
			text-align: center;

			.header-text {
				margin-left: 0;

				.page-title {
					font-size: 20px;
				}
			}

			.header-actions {
				margin-left: 0;
				width: 100%;
				display: flex;
					justify-content: center;

				.add-carousel-btn {
					padding: 10px 20px;
					font-size: 13px;
				}
			}
		}
	}

	.toolbar-section {
		.toolbar-card {
			padding: 16px;
		}
	}

	.table-section {
		.table-header {
			flex-direction: column;
			gap: 12px;
			text-align: center;

			.table-actions {
				width: 100%;
				display: flex;
				justify-content: center;
			}
		}

		.data-table {
			min-width: 700px;

			.config-name {
				gap: 8px;

				.config-icon {
					width: 28px;
					height: 28px;

					svg {
						width: 14px;
						height: 14px;
					}
				}

				.config-info {
					.config-title {
						font-size: 13px;
					}

					.config-description {
						font-size: 11px;
					}
				}
			}

			.config-value {
				.value-image {
					.config-img {
						width: 50px;
						height: 50px;
					}
				}
			}
		}
	}
}

@media (max-width: 480px) {
	.config-list-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-icon {
				width: 48px;
				height: 48px;

				.icon {
					width: 20px;
					height: 20px;
				}
			}

			.header-text {
				.page-title {
					font-size: 18px;
				}

				.page-description {
					font-size: 13px;
				}
			}

			.header-actions {
				.add-carousel-btn {
					padding: 8px 16px;
					font-size: 12px;
				}
			}
		}
	}

	.toolbar-section {
		.toolbar-card {
			padding: 16px;
		}
	}

	.table-section {
		.table-header {
			padding: 16px;

			.table-title {
				font-size: 16px;
			}
		}

		.data-table {
			min-width: 600px;
		}
	}

	.pagination-section {
		.data-pagination {
			padding: 16px;
			
			:deep(.el-pagination) {
				.el-pagination__total,
				.el-pagination__jump {
					display: none;
				}
			}
		}
	}

	.preview-dialog {
		:deep(.el-dialog) {
			width: 90% !important;
			margin: 20px;
		}

		:deep(.el-dialog__body) {
			padding: 16px;
		}
	}
}
</style>
